const SELECTED_PRODUCT_KEY = 'muidsoft:selectedProductId';
const ADVANCED_OPEN_KEY = 'muidsoft:advancedOpen';
const AUTH_PASSWORD_KEY = 'muidsoft:authPassword';

/**
 * Password auth (plaintext) disimpan di localStorage supaya user tidak perlu
 * login ulang tiap buka app — ini private single-user tool yang jalan di
 * device sendiri (PRD §20.3), bukan aplikasi multi-user, jadi trade-off ini
 * dianggap acceptable. JANGAN pakai pola ini untuk app multi-user.
 */
export function getAuthPassword(): string | null {
  return localStorage.getItem(AUTH_PASSWORD_KEY);
}

export function setAuthPassword(password: string): void {
  localStorage.setItem(AUTH_PASSWORD_KEY, password);
}

export function clearAuthPassword(): void {
  localStorage.removeItem(AUTH_PASSWORD_KEY);
}

export function getSelectedProductId(): string | null {
  return localStorage.getItem(SELECTED_PRODUCT_KEY);
}

export function setSelectedProductId(id: string): void {
  localStorage.setItem(SELECTED_PRODUCT_KEY, id);
}


export function getAdvancedOpen(): boolean {
  return localStorage.getItem(ADVANCED_OPEN_KEY) === '1';
}

export function setAdvancedOpen(open: boolean): void {
  localStorage.setItem(ADVANCED_OPEN_KEY, open ? '1' : '0');
}
